import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

/** Prefix shared by the picker and Builder queries, so one invalidation refreshes both. */
export const injection_contents_root_key = ["injection-contents"];

export interface AvailableInjectionContent {
    injection_substance: string;
    dose: number;
    unit: string;
    is_public: boolean;
    created_by: string | null;
}

/**
 * Injection contents for pickers: `available_injection_contents` already applies the visibility rule
 * (substance usable AND dose public, own, or substance granted). Builder pages read the base table
 * through `selectInjectionContentsForBuilder` instead.
 */
async function getInjectionContents(): Promise<AvailableInjectionContent[]> {
    const { data } = await supabaseClient.from("available_injection_contents").select("*").throwOnError();

    return (data ?? []).flatMap((row) =>
        row.injection_substance != null && row.dose != null && row.unit != null
            ? [
                  {
                      injection_substance: row.injection_substance,
                      dose: row.dose,
                      unit: row.unit,
                      is_public: row.is_public ?? false,
                      created_by: row.created_by,
                  },
              ]
            : []
    );
}

export const injection_contents_key = [...injection_contents_root_key, "available"];

export const injectionContentsQueryOptions = () => {
    return queryOptions({
        queryKey: injection_contents_key,
        queryFn: async () => getInjectionContents(),
        staleTime: 30_000,
    });
};

export function useInjectionContentsQuery() {
    return useQuery(injectionContentsQueryOptions());
}
